import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=77d874f8"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77d874f8')) {
      api.createRecord('77d874f8', component.options)
    } else {
      api.reload('77d874f8', component.options)
    }
    module.hot.accept("./HeaderMenu.vue?vue&type=template&id=77d874f8", function () {
      api.rerender('77d874f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/header/type_1/HeaderMenu.vue"
export default component.exports